//Back-end server
export const IP_BE = "https://api.dev.breathe4school.in";
//S3 bucket api
// export const IP = "http://b4spublic.s3-website.ap-south-1.amazonaws.com/";
// export const IP = "https://dxs5if5qoy7z5.cloudfront.net/";
export const IP = "https://public.breathe4school.ai/";
// export const IP = "http://localhost:3002";
